import script from "./StoryPoints.vue?vue&type=script&setup=true&lang=js"
export * from "./StoryPoints.vue?vue&type=script&setup=true&lang=js"

import "./StoryPoints.vue?vue&type=style&index=0&id=344f2763&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-344f2763"]])

export default __exports__